/**
 * 适用于GA的数据埋点方法
 */

//埋点事件类别
const CATEGORY = ['注册/登录', '酒店预订', '机票预订', '领取流量']

/**
 * GA记录
 * @param {Number} type 埋点事件类别
 * @param {String} action 事件名
 * @param {*} params 事件参数
 */
const _gtag = (type, action, params) => {
    gtag("event", action, {
        event_category: CATEGORY[type],
        event_label: JSON.stringify(params),
        send_to: process.env.NODE_ENV === 'production' ? "UA-123162326-1" : 'G-KQLC18HE3F'
    });
}

/**
 * 记录注册
 * @param {*} params 
 */
export const signupGtag = params => {
    _gtag(0, '注册', params)
}

/**
 * 账号登录
 * @param {*} params 
 */
export const signinGtag = params => {
    _gtag(0, '账号登录', params)
}

/**
 * 第三方登录
 * @param {*} params 
 */
export const thirdPartyLoginGtag = params => {
    _gtag(0, '第三方登录', params)
}

/**
 * 首页特价精选列表
 * @param {*} params 
 */
export const topdealsGtag = params => {
    _gtag(1, '首页特价精选列表', params)
}

/**
 * 酒店预订房型
 * @param {*} params 
 */
export const bookingRoomGtag = params => {
    _gtag(1, '预订房型', params)
}

/**
 * 收藏酒店
 * @param {*} params 
 */
export const collectHotelGtag = params => {
    _gtag(1, '收藏酒店', params)
}

/**
 * 首页促销活动的点击
 * @param {String} params 
 */
export const promotionHotelGtag = params => {
    _gtag(1, '促销活动的名称', params)
}

/**
 * 首页banner的点击
 * @param {*} params 
 */
export const bannerGtag = params => {
    _gtag(1, '首页banner', params)
}

/**
 * 酒店——酒店搜索
 * @param {*} params 
 */
export const searchHotelByHotelGtag = params => {
    _gtag(1, '酒店——酒店搜索', params)
}

/**
 * 酒店——城市搜索
 * @param {*} params 
 */
export const searchCityByHotelGtag = params => {
    _gtag(1, '酒店——城市搜索', params)
}

/**
 * 酒店订单详情填写
 * @param {*} params 
 */
export const bookingHotelFormGtag = params => {
    _gtag(1, '酒店订单详情填写', params)
}

/**
 * 酒店订单支付
 * @param {*} params 
 */
export const hotelPayGtag = params => {
    _gtag(1, '酒店支付', params)
}

/**
 * 酒店搜索列表排序条件埋点
 * @param {String} sortType 排序条件
 */
export const hotelListSortGtag = sortType => {
    _gtag(1, '酒店搜索列表的排序条件', sortType)
}

/**
 * 酒店搜索列表位置条件埋点
 * @param {String} sortType 哪个位置
 */
export const hotelListFilterByLocationGtag = sortType => {
    _gtag(1, '酒店搜索列表的位置条件', sortType)
}

/**
 * 机票搜索
 * @param {*} params 
 */
export const flightSearchGtag = params => {
    _gtag(2, '机票搜索', params)
}

/**
 * 机票搜索结果——排序条件
 * @param {*} params 
 */
export const flightSortGtag = params => {
    _gtag(2, '机票搜索结果-排序条件', params)
}

/**
 * 机票搜索结果——筛选条件——航空公司
 * @param {*} params 
 */
export const flightFilterCompanyGtag = params => {
    _gtag(2, '机票搜索结果-筛选条件-航司', params)
}

/**
 * 机票订单生成 详情信息
 * @param {*} params 
 */
export const flightBookingDetailGtag = params => {
    _gtag(2, '机票订单详情信息', params)
}

/**
 * 机票支付
 * @param {*} params 
 */
export const flightPayGtag = params => {
    _gtag(2, '机票支付', params)
}

/**
 * 流量优惠券领取页面
 * @param {*} params 
 */
export const freedataReceiveGtag = params => {
    _gtag(3, '流量优惠券领取页面', params)
}


// WEBPACK FOOTER //
// ./src/lib/gtag.js